module.exports = __webpack_public_path__ + "static/media/towel.29afc1d7.png";